import { useDimensions } from "@repo/core/hooks/useDimensions";
import { ROUTES } from "@repo/core/routes";
import { useProposalFlowNavigation } from "../utils/proposalFlowNavigation";
import { useState } from "react";
import { useProposal } from "@repo/core/hooks/useProposal";
import {
  resolveIsFidelitySelection,
  syncSelectedServicePointToProposalFlow
} from "./servicePointSelection";
import { useProposalServicePoints } from "@repo/core/hooks/useProposalServicePoints";
import { useCreditProposalStore } from "../Credit/store";
import { useFidelityProposalStore } from "../Fidelity/store";

export const SelectServicePointController = () => {
  const { completeStep, goToPreviousStep, routeParams } =
    useProposalFlowNavigation();
  const { isMobile } = useDimensions();
  const { selectedServicePoint, setSelectedServicePoint, isFidelityProposal } =
    useProposal();
  const isFidelitySelection = resolveIsFidelitySelection(
    routeParams?.isFidelityProposal,
    isFidelityProposal
  );
  const creditProposalData = useCreditProposalStore(
    (state) => state.proposalData
  );
  const fidelityProposalData = useFidelityProposalStore(
    (state) => state.proposalData
  );
  const proposalData = isFidelitySelection
    ? fidelityProposalData || creditProposalData
    : creditProposalData || fidelityProposalData;

  const [selectedServicePointId, setSelectedServicePointId] = useState<
    string | null
  >(proposalData?.strPontoAtendimento || selectedServicePoint?.ponto || null);
  const { data: servicePoints, isFetching: isFetchingServicePoints } =
    useProposalServicePoints(
      proposalData?.strProduto,
      proposalData?.strBandeira
    );

  const handleSelectServicePoint = (id: string) => {
    setSelectedServicePointId(id);
  };

  const handleOnSubmitForm = () => {
    const point = servicePoints?.find(
      (p) => p.ponto === selectedServicePointId
    );

    if (point) {
      setSelectedServicePoint(point);
      syncSelectedServicePointToProposalFlow(point, isFidelitySelection);
    }

    if (isFidelitySelection) {
      completeStep(ROUTES.fidelityProposalReview);
      return;
    }

    completeStep(ROUTES.creditProposalReview);
  };

  const handleGoBack = () => {
    if (isFidelitySelection) {
      goToPreviousStep(ROUTES.fidelityProposalReview);
      return;
    }
    goToPreviousStep(ROUTES.creditProposalReview);
  };

  return {
    handleOnSubmitForm,
    handleGoBack,
    handleSelectServicePoint,
    isMobile,
    servicePoints,
    selectedServicePointId,
    isFetchingServicePoints
  };
};
